import { Alert, AlertTitle, Link } from '@mui/material';
import React, { FC } from 'react';
import { useGuideCmsContext } from './GuideCmsContext';
import { Link as RouterLink } from 'react-router-dom';

export const ArchiveDocumentInfo: FC = () => {
  const { guide, archivedVersion } = useGuideCmsContext();
  if (!guide) return null;
  return (
    <Alert severity="warning">
      <AlertTitle>Utgått dokument</AlertTitle>
      Du redigerer nå på en utgått versjon av anvisningen (v {archivedVersion}). <br />
      Hvis du ikke holder på med å migrere utgåtte anvisninger over til CMS,{' '}
      <Link component={RouterLink} to={`/guide-editor/${guide.id}/edit`}>
        gå til nyeste versjon
      </Link>
      .
    </Alert>
  );
};
